import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCryptorsLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 293,
	height: 152,
	viewBox: "0 0 293 152",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M 143.1 111.4 V 74.5 H 134.9 V 66.3 H 159.5 V 74.5 H 151.3 V 111.4 H 143.1 Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M 251.1 74.5 H 247 V 86.8 H 251.1 V 74.5 Z M 238.8 111.4 V 66.3 H 259.3 V 86.8 L 255.2 90.9 L 259.3 95 V 111.4 H 251.1 V 95 H 247 V 111.4 H 238.8 H 238.8 Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M 0 66.3 V 111.4 H 20.5 V 95 H 12.3 V 103.2 H 8.2 V 74.5 H 12.3 V 82.7 H 20.5 V 66.3 H 0 Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M 46 74.5 H 41.9 V 86.8 H 46 V 74.5 Z M 33.7 111.4 V 66.3 H 54.2 V 86.8 L 50.1 90.9 L 54.2 95 V 111.4 H 46 V 95 H 41.9 V 111.4 H 33.7 H 33.7 Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M 73.6 111.4 V 90.9 H 67.5 V 66.3 H 75.7 V 82.7 H 79.7 V 66.3 H 87.9 V 90.9 H 81.8 V 111.4 H 73.6 Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M 113.5 74.5 H 109.4 V 86.8 H 113.5 V 74.5 Z M 101.2 111.4 V 66.3 H 121.7 V 95 H 109.4 V 111.4 H 101.2 Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M 272.5 66.3 V 90.9 H 284.8 V 103.2 H 280.7 V 99.1 H 272.5 V 111.4 H 293 V 82.7 H 280.7 V 74.5 H 284.8 V 78.6 H 293 V 66.3 H 272.5 Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M 134.7 135 H 131.2 L 135.4 147.1 L 135 148.1 C 134.9 148.6 134.6 148.9 134.3 149.1 C 134 149.3 133.6 149.3 132.9 149.3 L 132.5 149.3 V 151.8 C 132.9 151.9 133.4 152 133.9 152 C 135.5 152 136.7 151.2 137.5 149.6 L 137.7 149 L 142.6 135 H 139.1 L 136.9 142.5 L 134.6 135 L 134.7 135 Z M 124.4 132 V 135 H 122.6 V 137.4 H 124.4 V 143.9 C 124.4 146.2 125.6 147.3 127.8 147.3 C 128.5 147.3 129.2 147.2 129.8 147 V 144.6 C 129.5 144.6 129.2 144.7 128.8 144.7 C 128.4 144.7 128 144.6 127.9 144.4 C 127.7 144.2 127.6 143.9 127.6 143.4 V 137.4 H 129.7 V 135 H 127.6 V 132 H 124.4 V 132 Z M 117.2 133.1 C 117.6 133.4 118 133.6 118.5 133.6 C 119.1 133.6 119.5 133.4 119.9 133.1 C 120.2 132.8 120.3 132.4 120.3 131.9 C 120.3 131.4 120.2 131 119.9 130.7 C 119.5 130.4 119.1 130.2 118.5 130.2 C 118 130.2 117.5 130.4 117.2 130.7 C 116.9 131 116.7 131.4 116.7 131.9 C 116.7 132.4 116.9 132.8 117.2 133.1 M 120.2 135 H 116.9 V 147.1 H 120.2 V 135 Z M 107.2 143.9 C 106.8 143.4 106.6 142.5 106.6 141.2 V 140.9 C 106.6 139.7 106.8 138.8 107.2 138.2 C 107.6 137.7 108.2 137.4 108.9 137.4 C 109.5 137.4 110 137.6 110.4 138 C 110.8 138.4 110.9 138.9 111 139.5 H 114 C 114 138.1 113.5 136.9 112.6 136.1 C 111.7 135.2 110.5 134.8 109 134.8 C 107.2 134.8 105.9 135.3 104.9 136.5 C 103.9 137.6 103.4 139.1 103.4 140.9 V 141.1 C 103.4 143.1 103.9 144.6 104.9 145.7 C 105.9 146.8 107.3 147.3 109 147.3 C 109.9 147.3 110.8 147.2 111.5 146.8 C 112.3 146.4 112.9 145.9 113.3 145.2 C 113.8 144.5 114 143.8 114 142.9 H 111 C 111 143.5 110.8 143.9 110.4 144.2 C 110 144.6 109.5 144.7 108.9 144.7 C 108.2 144.7 107.6 144.5 107.2 143.9 M 90.8 138 C 91.2 138.4 91.4 138.9 91.4 139.7 V 139.9 H 86.9 C 87 139.1 87.3 138.5 87.6 138.1 C 88 137.6 88.6 137.4 89.2 137.4 C 89.9 137.4 90.4 137.6 90.8 138 M 92.3 146.8 C 93.2 146.4 93.8 145.8 94.3 145.2 L 92.7 143.4 C 92 144.3 91 144.7 89.8 144.7 C 89 144.7 88.3 144.5 87.8 144 C 87.3 143.5 87 142.9 86.9 142.1 H 94.6 V 140.8 C 94.6 138.9 94.1 137.4 93.1 136.4 C 92.2 135.3 90.9 134.8 89.2 134.8 C 88.1 134.8 87.1 135 86.3 135.6 C 85.4 136.1 84.7 136.8 84.3 137.8 C 83.8 138.7 83.6 139.8 83.6 141 V 141.4 C 83.6 143.2 84.1 144.6 85.2 145.7 C 86.4 146.8 87.8 147.3 89.6 147.3 C 90.6 147.3 91.5 147.1 92.3 146.8 M 73.4 129.9 H 70.2 V 147.1 H 73.4 V 138.5 C 73.9 137.8 74.5 137.4 75.5 137.4 C 76.2 137.4 76.7 137.6 77 137.9 C 77.3 138.3 77.4 138.8 77.4 139.5 V 147.1 H 80.7 V 139.4 C 80.6 136.3 79.3 134.8 76.7 134.8 C 75.4 134.8 74.3 135.3 73.4 136.3 V 129.9 Z M 62.3 132 V 135 H 60.5 V 137.4 H 62.3 V 143.9 C 62.3 146.2 63.5 147.3 65.7 147.3 C 66.4 147.3 67.1 147.2 67.7 147.1 V 144.6 C 67.4 144.7 67.1 144.7 66.7 144.7 C 66.3 144.7 65.9 144.6 65.8 144.4 C 65.6 144.2 65.5 143.9 65.5 143.4 V 137.4 H 67.6 V 135 H 65.5 V 132 H 62.3 V 132 Z M 41.2 135 V 147.1 H 44.4 V 138.6 C 44.9 137.8 45.6 137.4 46.5 137.4 C 47.2 137.4 47.7 137.6 48 137.9 C 48.3 138.2 48.4 138.7 48.4 139.4 V 147.1 H 51.7 V 139.3 C 51.6 137.8 51.3 136.7 50.7 135.9 C 50.1 135.2 49.1 134.8 47.8 134.8 C 46.4 134.8 45.2 135.3 44.4 136.4 L 44.3 135 H 41.2 L 41.2 135 Z M 34.8 133.1 C 35.1 133.4 35.5 133.6 36.1 133.6 C 36.6 133.6 37.1 133.4 37.4 133.1 C 37.7 132.8 37.9 132.4 37.9 131.9 C 37.9 131.4 37.7 131 37.4 130.7 C 37.1 130.4 36.6 130.2 36.1 130.2 C 35.5 130.2 35.1 130.4 34.8 130.7 C 34.4 131 34.3 131.4 34.3 131.9 C 34.3 132.4 34.4 132.8 34.8 133.1 Z M 37.7 135 H 34.5 V 147.1 H 37.7 V 135 Z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M 183.5 46.9 C 183.3 45.7 182.1 45 180.9 45.2 C 179.8 45.4 179 46.5 179.2 47.7 C 179.4 48.9 180.6 49.6 181.7 49.4 C 182.9 49.2 183.7 48.1 183.5 46.9 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 190.7 72.7 V 57.2 L 182.8 48.6",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 254.8 129.1 C 256 129.3 256.8 130.4 256.6 131.6 C 256.4 132.7 255.2 133.5 254.1 133.3 C 252.9 133.1 252.1 132 252.3 130.8 C 252.5 129.6 253.7 128.8 254.8 129.1 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 216 99.8 H 222.7 L 252.7 129.7",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 202.7 58.9 C 202.9 57.7 204 56.9 205.2 57.1 C 206.4 57.4 207.1 58.5 206.9 59.7 C 206.7 60.8 205.6 61.6 204.4 61.4 C 203.2 61.2 202.5 60.1 202.7 58.9 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 204.8 72.9 V 60.8",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 184.7 2.5 C 184.9 1.3 186 0.6 187.2 0.8 C 188.4 1 189.2 2.1 189 3.3 C 188.7 4.5 187.6 5.2 186.4 5 C 185.3 4.8 184.5 3.7 184.7 2.5 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 244.4 40.9 C 244.2 39.7 243.1 38.9 241.9 39.1 C 240.7 39.3 240 40.5 240.2 41.6 C 240.4 42.8 241.5 43.6 242.7 43.4 C 243.9 43.2 244.6 42 244.4 40.9 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 211.3 72.7 V 67.1 C 211.3 67.1 210.4 60.1 220.2 60.1 C 230 60.1 230.9 57.3 230.9 57.3 L 241.4 43.5",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 176 129.2 C 176.2 128.1 177.4 127.3 178.5 127.5 C 179.7 127.7 180.5 128.8 180.3 130 C 180.1 131.2 178.9 132 177.8 131.8 C 176.6 131.5 175.8 130.4 176 129.2 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 190.8 105 V 117.1 L 179.8 128",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 196.3 141.7 C 195.6 140.7 195.9 139.4 196.9 138.7 C 197.9 138 199.2 138.3 199.9 139.3 C 200.5 140.3 200.3 141.6 199.3 142.3 C 198.3 143 196.9 142.7 196.3 141.7 H 196.3 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 198.1 105 V 138.3",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 204.9 105 V 114.8 C 204.9 114.8 204.9 118.8 209.3 118.5 C 212.3 118.3 213 120.2 213 123.1",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 211.3 126.5 C 210.6 125.5 210.8 124.1 211.8 123.5 C 212.8 122.8 214.2 123.1 214.8 124.1 C 215.5 125 215.2 126.4 214.2 127.1 C 213.3 127.7 211.9 127.5 211.2 126.5 H 211.3 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 168.7 105.8 C 168.4 104.6 167.3 103.8 166.1 104.1 C 165 104.3 164.2 105.4 164.4 106.6 C 164.6 107.8 165.7 108.5 166.9 108.3 C 168.1 108.1 168.9 107 168.7 105.8 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 185.9 98.1 H 172.4 C 172.4 98.1 167.2 99.3 167.2 104.4",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 178.1 91.3 C 177.9 90.1 176.7 89.4 175.6 89.6 C 174.4 89.8 173.6 90.9 173.8 92.1 C 174 93.3 175.2 94 176.3 93.8 C 177.5 93.6 178.3 92.5 178.1 91.3 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 185.9 91.7 H 177.7",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 186.8 85.1 H 175.3 C 175.3 85.1 170.6 86 170.6 80.3 C 170.6 80.3 171.4 77.6 165.9 77.6 H 123.9",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 123.8 77 C 123.5 75.9 122.4 75.1 121.2 75.3 C 120.1 75.5 119.3 76.6 119.5 77.8 C 119.7 79 120.8 79.8 122 79.6 C 123.2 79.3 124 78.2 123.8 77 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 174.6 64.5 C 174.4 63.3 173.2 62.6 172.1 62.8 C 170.9 63 170.1 64.1 170.3 65.3 C 170.5 66.5 171.7 67.2 172.8 67 C 174 66.8 174.8 65.7 174.6 64.5 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 186.8 78.8 H 178.6 C 178.6 78.8 172.4 79.4 172.4 70.8 V 67.1",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 240.6 66.7 C 240.4 65.6 239.2 64.8 238.1 65 C 236.9 65.2 236.1 66.3 236.3 67.5 C 236.5 68.7 237.7 69.5 238.8 69.2 C 240 69 240.8 67.9 240.6 66.7 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 215.1 78 H 229.6 L 236.6 68.2",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 268 85.8 C 267.8 84.6 266.6 83.8 265.5 84 C 264.3 84.2 263.5 85.4 263.7 86.5 C 263.9 87.7 265.1 88.5 266.2 88.3 C 267.4 88.1 268.2 86.9 268 85.8 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 215.1 86.2 H 264.3",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 215.1 92.8 H 229.1 C 230.9 94 231.1 96.4 232.3 98.1 C 233.3 99.5 234.9 100.3 236.6 100.7 C 238.2 101 240.1 100.7 240.1 100.7",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 244.4 100.5 C 244.2 99.4 243.1 98.6 241.9 98.8 C 240.7 99 240 100.1 240.2 101.3 C 240.4 102.5 241.5 103.3 242.7 103.1 C 243.9 102.8 244.6 101.7 244.4 100.5 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 222 115.3 C 221.3 114.3 221.6 112.9 222.6 112.2 C 223.6 111.6 224.9 111.8 225.6 112.8 C 226.3 113.8 226 115.2 225 115.8 C 224 116.5 222.7 116.2 222 115.3 H 222 Z",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 210.7 104.5 C 209.6 109.1 212.7 111.3 215.8 113.5 C 216.6 114.1 217.7 114 218.6 114 C 219.6 114.1 220.6 114 221.6 114",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 197.3 73.9 V 41.3 C 197.3 41.3 197.9 36.2 193.6 36.2 C 193.6 36.2 186.9 37.7 186.9 29.5 V 5.4",
			stroke: "#eb605a",
			strokeWidth: 1.48505,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M 192.5 80 H 210.3 V 97.8 H 192.5 V 80 Z M 194.1 81.7 V 96.2 H 208.6 V 81.7 H 194.1 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M 189.3 76.8 V 101 H 213.4 V 76.8 H 189.3 Z M 184.8 75.9 C 184.8 73.9 186.4 72.4 188.4 72.4 H 214.3 C 216.3 72.4 217.9 74 217.9 75.9 V 101.9 C 217.9 103.9 216.3 105.5 214.3 105.5 H 188.4 C 186.4 105.5 184.8 103.9 184.8 101.9 V 75.9 Z"
		})
	]
});
export default SvgCryptorsLogo;
